import React from 'react';

import Modal from 'components/shared/GlobalModalArea/Modal';

import { EnterPortalTable } from './EnterPortalTable';
import s from './index.module.css';
import { IEnterPortalModalProps } from './types';

export const EnterPortalModal = ({ res, guestPortals }: IEnterPortalModalProps) => {
  return (
    <Modal closeButtonClassName={s.closeButton} isOpen toClose={res} contentClassName={s.modalWrapper}>
      <div className={s.modalHeader}>Which Guest Portal would you like to edit?</div>
      <div className={s.modalBody}>
        <EnterPortalTable guestPortals={guestPortals} />
      </div>
    </Modal>
  );
};
